<div
  class="email-view-container"
  [class]="isNewTab ? 'email-view-container-new-tab' : ''"
>
  @if (!this.isChanged) {
  <div>
    <app-summarize-chat
      [data]="data"
      [selected]="selection"
    ></app-summarize-chat>
  </div>
  }

  <div #emailViewBody [class]="_action.isShowExtractedEntity ? 'flex email-view-body-container':'flex email-view-body-container email-view-body-container-entity'" >
    <p-splitter>
      <ng-template pTemplate>
        <div class="email-view-body secondary-shadow flex-1">
          <!-- head -->
          <app-email-head
            [headerData]="data._source"
            [toolbar]="toolbar"
          ></app-email-head>
          <app-attachment-view
            [attachments]="data._source.Attachment"
          ></app-attachment-view>
          <!-- body -->
          @if (emlHtml && !isLoading && isEmailAPIView) {
          <app-eml-view
            [data]="data"
            [emlHtml]="emlHtml"
            emlHeight="calc(100vh - var(--topNav-height))"
            style="display: block"
          >
          </app-eml-view>
          }@else if (emailContent && !isLoading ) {
          <app-eml-view
            [data]="data"
            [emlHtml]="emailContent"
            emlHeight="calc(100vh - var(--topNav-height)"
            style="display: block"
          >
          </app-eml-view>
          }@else { @if(isLoading){
          <p-skeleton
            width="100%"
            styleClass="mt-3"
            height="calc(100vh - var(--topNav-height)"
          />
          }@else {
          <div
            class="no-content-found flex justify-content-center align-items-center"
          >
            <p class="text-base text-color-secondary text-center">
              No email content to display at the moment
            </p>
          </div>
          } }
          <div class="mt-2" id="comment-section">
            <app-comments [data]="data"></app-comments>
          </div>
        </div>
      </ng-template>
       <ng-template pTemplate>

         @if (_action.isShowExtractedEntity) {
         <div
           class="secondary-shadow extracted-entity-viewer"
           style="height: inherit"
         >
           <app-extraction-detail
             [extraction]="_extraction.selectedExtractionForSearch"
             [maxHeight]="emailViewBodyHeight"
             [close]="closeExtractionDetails"
           ></app-extraction-detail>
         </div>
         }
       </ng-template>
    </p-splitter>

  </div>
</div>
